import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCampaignGigs, fetchCampaignMilestones } from "services/api/campaign";
import { ERROR } from "types";
import { CampaignGig, CampaignMilestonesResponse } from "types/campaign/milestones";
import { getErrorMessage } from "utils/helpers";

export const fetchCampaignMilestonesThunk = createAsyncThunk<
    { milestonesData: CampaignMilestonesResponse, campaignId: string },
    string,
    { rejectValue: string }
>(
    'campaign/milestones/fetch',
    async (campaignId, { rejectWithValue }) => {
        try {
            const milestones = await fetchCampaignMilestones(campaignId);
            return { milestonesData: milestones, campaignId };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
);

export const fetchCampaignGigsThunk = createAsyncThunk<
    { gigs: CampaignGig[], campaignId: string },
    string,
    { rejectValue: string }
>(
    'campaign/milestones/fetchGigs',
    async (campaignId, { rejectWithValue }) => {
        try {
            const gigs = await fetchCampaignGigs(campaignId);
            return { gigs, campaignId };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
);
